export default {
    priority: {
        low: 'Baixa',
        normal: 'Normal',
        high: 'Alta',
        urgent: 'Urgente',
    },
    priority_integer: {
        4: 'Baixa',
        3: 'Normal',
        2: 'Alta',
        1: 'Urgente',
    },
    attendance_type_status: {
        start: 'Em Andamento',
        finish: 'Concluído',
        pause: 'Pausado',
        idle: 'Sem ação',
    },
    taskier_documents: {
        privacy_policy: 'Política de Privacidade',
        terms_of_use: 'Termos de Uso',
    },
    service_chat_status: {
        'in-progress': 'Em Progresso',
        waiting: 'Em Espera',
        unanswered: 'Não Atendido',
        finished: 'Encerrado',
    },
    holiday_scope: {
        municipal: 'Municipal',
        state: 'Estadual',
        federal: 'Federal',
    },
    user_type: {
        admin: 'Administrador',
        agent: 'Agente',
        customer: 'Cliente',
        'guest-email': 'E-mail',
    },
    task_status: {
        open: 'Em Andamento',
        paused: 'Pausado',
        done: 'Concluído',
    },
    deadline_status: {
        overdue: 'Atrasado',
        'on-schedule': 'Em Dia',
        'no-deadline': 'Sem Prazo',
    },
    article_status: {
        published: 'Publicado',
        'in-review': 'Em Revisão',
    },
    tenant_subscription_status: {
        active: 'Ativo',
        overdue: 'Não Pago',
        trialing: 'Período de Teste',
        canceled: 'Cancelado',
    },
    tenant_payment_status: {
        confirmed: 'Confirmado',
        pending: 'Aguardando Pagamento',
        received: 'Recebido',
        overdue: 'Vencido',
        refunded: 'Estorno',
        refund_requested: 'Estorno Requerido',
        chargeback_requested: 'Chargeback Requerido',
    },
    connection_status: {
        success: 'Conectado',
        failed: 'Problema na conexão',
    },
}
